// The width a breakpoint FRAME actually renders at on the builder canvas =
// live ruler-drag preview width, else the breakpoint's base width. The scale
// feature and the ScaleControl anchor capture BOTH resolve against this (never
// window.innerWidth, which is the OS window, not the frame) so a scaled element
// previews at the width it will render at for that surface. Mirrors
// CanvasBreakpointFrame's baseWidth/currentWidth so the frame and the scale agree.

const DEFAULT_UNBOUNDED_WIDTH_PX = 1200;

function parsePxValue(raw) {
  const n = parseInt(raw, 10);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

// The frame's width with no ruler-drag preview applied — the breakpoint's own
// value, else (value-less "Default" frame) the narrowest (mobile-first) or widest
// (desktop-first) configured breakpoint, else the unbounded default.
function baseWidthForAlias(alias, breakpoints = [], designVariant = "desktop") {
  const entry = breakpoints.find(bp => (bp?.alias || "default") === alias);
  const own = parsePxValue(entry?.value);
  if (own > 0) {
    return own;
  }
  const configured = breakpoints.map(bp => parsePxValue(bp?.value)).filter(width => width > 0);
  if (designVariant === "mobile" && configured.length) {
    return Math.min(...configured);
  }
  if (designVariant === "desktop" && configured.length) {
    return Math.max(...configured);
  }
  return DEFAULT_UNBOUNDED_WIDTH_PX;
}

function frameSurfaceWidth({ alias, previewWidths = {}, breakpoints = [], designVariant = "desktop" } = {}) {
  const preview = Number(previewWidths?.[alias]);
  if (Number.isFinite(preview) && preview > 0) {
    return Math.round(preview);
  }
  return baseWidthForAlias(alias, breakpoints, designVariant);
}

module.exports = {
  DEFAULT_UNBOUNDED_WIDTH_PX,
  parsePxValue,
  baseWidthForAlias,
  frameSurfaceWidth,
};
